import { generateOptions } from 'utils/options';

export const educationTypeOptions = generateOptions('educationTypes');
export const trainingTypeOptions = generateOptions('trainingTypes');
export const assignedQualificationOptions =
    generateOptions('qualificationTypes');
export const issuedDocumentsOptions = generateOptions('issuedDocuments');
export const gradeTypesOptions = generateOptions('gradeTypes');
export const disciplineTypeOptions = generateOptions('disciplineTypes');
export const extendedDocumentTypeOptions = generateOptions(
    'extendedDocumentTypes'
);
export const documentTypeOptions = generateOptions('documentTypes');
